// Keys for data which we store in sessionStorage
export const sessionStorageKeys = {
  adminOverrideAccountGUID: 'adminOverrideAccountGUID',
  adminOverrideAccountName: 'adminOverrideAccountName',
  adminOverrideAccountEmail: 'adminOverrideAccountEmail',
  adminOverrideAccountCompanyName: 'adminOverrideAccountCompanyName',
  hasViewedPoliticalTerms: 'hasViewedPoliticalTerms',
} as const;
